import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaInstagram, FaXTwitter, FaLinkedinIn } from "react-icons/fa6";
import { useLang } from "../lib/LangContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-lokam-border bg-lokam-cream">
      <div className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <img
                src="https://customer-assets.emergentagent.com/job_medicine-dial/artifacts/897ara6e_Primary%20-%20Logo.svg"
                alt="Lokam"
                className="h-11 w-auto"
              />
              <span className="font-display font-semibold text-lg text-lokam-forest tracking-tight">
                Health
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-lokam-ink-soft leading-relaxed">
              {t.footer.tagline}
            </p>

            <div className="mt-6 flex items-center gap-3">
              {[FaWhatsapp, FaInstagram, FaXTwitter, FaLinkedinIn].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  className="h-9 w-9 rounded-full bg-white border border-lokam-border flex items-center justify-center text-lokam-forest hover:bg-lokam-forest hover:text-lokam-cream transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.18em] font-bold text-lokam-tangerine">
              {t.footer.links_legal}
            </div>
            <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2.5 text-sm text-lokam-ink-soft">
              {t.footer.legal.map((l, i) => (
                <li key={i}>
                  <Link
                    to={l.to}
                    data-testid={`footer-policy-link-${l.to.replace(/\//g, "")}`}
                    className="hover:text-lokam-forest transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-lokam-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-xs text-lokam-ink-soft">{t.footer.rights}</div>
          <div className="text-xs text-lokam-ink-soft">
            Pharmacy license · D&C Act compliant · Made in Bengaluru
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
